import styled from 'styled-components';
import { vars } from '@snsw-gel/theming';

export const FooterWrapper = styled.footer`
  background-color: ${vars.colors.primary};
  color: ${vars.colors.primary.text};
  width: 100%;
  margin-top: 3rem;
`;

export const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;
